import DatasetsResultsListItemWithState from "@components_common/components/items/DatasetsResultListItem.jsx";

export default DatasetsResultsListItemWithState;
